// extracted by mini-css-extract-plugin
export var text = "_ar-0";